// extracted by mini-css-extract-plugin
export default {"benefits":"Benefits_benefits__HP2tc","benefitItem":"Benefits_benefitItem__V0Uvk","icon":"Benefits_icon__eEckV","highlight":"Benefits_highlight__FvimK"};